import "./GarageDoorRepairWollongong.module.css";
import Header from "@/reusable_sections/Header";
import Wollongonghero from "./sections/Wollongonghero";
import WollongongServices from "./sections/WollongongServices";
import Brands from "./sections/Brands";
import ServiceProcess from "./sections/ServiceProcess";
import WhyChooseUs from "./sections/WhyChooseUs";
import Suburbs from "./sections/Suburbs";
import CustomerReviews from "./sections/CustomerReviews";
import Wollongongfaq from "./sections/Wollongongfaq";
import LocationCta from "./sections/LocationCta";
import CompanyFooter from "./sections/CompanyFooter";
export default function GarageDoorRepairWollongongPage() {
  return <div>
      <Header />
      <Wollongonghero />
      <WollongongServices />
      <Brands />
      <ServiceProcess />
      <WhyChooseUs />
      <Suburbs />
      <CustomerReviews />
      <Wollongongfaq />
      <LocationCta />
      <CompanyFooter />
    </div>;
}